import React from 'react';

import { ToggleSwitch } from '@eika/toggle-switch';

import { useSetCardRules } from '@/react-query/hooks/mutation/use-set-card-rules';
import { useCard } from '@/react-query/hooks/query/use-card';
import useCardRules from '@/react-query/hooks/query/use-card-rules';

import useText from '@hooks/use-text';

const EcommerceSetting = () => {
    const text = useText();
    const { data: card } = useCard();
    const { data: cardRules, isPending: isLoadingCardRules } = useCardRules();
    const { mutate, isPending: isSettingCardRules } = useSetCardRules();
    const { getOnlineSpending, setOnlineSpending } = card?.allowedOperations || {};

    if (typeof cardRules === 'undefined' || typeof card === 'undefined') {
        return null;
    }

    const handleEcommerceChange = (value: boolean) => {
        mutate({ cardType: card.type, cardId: card.id, cardRules: { ...cardRules, ecommerce: value } });
    };
    if (!getOnlineSpending) {
        return <p className="ecommerce-not-allowed">{text.regionEcommerceInfoChild}</p>;
    }

    return (
        <div className="card-control__settings__setting__ecommerce">
            <span>{text.cardControlEcommerceTitle}</span>
            <ToggleSwitch
                checked={cardRules.ecommerce}
                onChange={handleEcommerceChange}
                ariaLabel={text.cardControlEcommerceTitle}
                disabled={isLoadingCardRules || isSettingCardRules || (getOnlineSpending && !setOnlineSpending)}
            />
        </div>
    );
};

export default EcommerceSetting;
